import HeaderImage1 from '../../assets/header1.jpg'
import HeaderImage2 from '../../assets/header2.jpg'
import data from './data'
// import useMediaQuery from './useMediaQuery';
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'
import { useState, useEffect } from 'react';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => setMatches(event.matches);

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [query]);

  return matches;
}


const Header = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  const text ="MEng Mechanical Engineer with a strong drive to develop sustainable, efficient solutions that make a real-world impact. I’m committed to exceeding industry standards through a blend of technical expertise and creative problem-solving. I thrive in collaborative environments, where I bring innovative yet practical approaches to complex challenges—bridging engineering, software, and systems thinking to deliver meaningful results.";
  return (
    <header id="header">
      <div className="container header__container">
        {isSmallScreen ? (
          <div className="header__profile" data-aos="fade-up">
            <img src={HeaderImage2} alt="Header Portrait" />
          </div>
          ) : (
          <div className="header__profile" data-aos="fade-up">
            <img src={HeaderImage1} alt="Header Portrait" />
          </div>)}
        {isSmallScreen ? (
          <h3>Stamatis Platokoukis</h3>
        ) : (
          <h3 data-aos="fade-up">Stamatis Platokoukis</h3>
        )}
         <p data-aos={!isSmallScreen ? "fade-up" : undefined}>
          {text}
         </p>
        {isSmallScreen ? (
         <div className="header__cta" >
         <a href="#contact" className='btn primary'>Let's Talk</a>
         {/* <a href="#portfolio" className='btn light'>My Work</a> */}
       </div>
        ) : (
          <div className="header__cta" data-aos="fade-up">
            <a href="#contact" className='btn primary'>Let's Talk</a>
            {/* <a href="#portfolio" className='btn light'>My Work</a> */}
          </div>
        )}
        <div className="header__socials" data-aos="fade-up">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header;
/* I thrive in collaborative environments where teamwork and open communication foster creativity and innovation, as I believe that diverse perspectives lead to better solutions and a more enjoyable work experience for everyone involved. Currently, I am learning Java Spring Boot and React JS. */

